import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import Moment from 'react-moment';//Both are required here
import moment from 'moment'; //Both are required here
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const CompletedLotsReport = () => {
    const [summaryReportData, setSummaryReportData] = useState({});
    const [detailReportData, setDetailReportData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const api = useApi();
    const navigate = useNavigate();

    const loadReport = async () => {
        await api.getCompletedLotsReport().then((data) => {
            setSummaryReportData(data.summary);
            setDetailReportData(data.details);
        })
    }

    useEffect(() => {
        loadReport();
    }, []);

 

    const qtyRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat suffix={' Kg'} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const columns = [
        { headerName: 'Lot No.', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 90 },
        { headerName: 'Auctioneer', field: 'auctioneer', headerClass: 'text-center', flex: 1 },
        { headerName: 'Quanity', field: 'quantityKg', headerClass: 'text-end', type: 'rightAligned', cellClass: 'text-end', width: 100, cellRenderer: qtyRenderer },
        { headerName: 'Bags', field: 'bags', headerClass: 'text-center', cellClass: 'text-center', width: 100 },
        { headerName: 'Liter Weight', field: 'litreWeightGms', headerClass: 'text-end', cellClass: 'text-center', width: 100, cellRenderer: qtyRenderer },
        { headerName: 'Rate/kg', field: 'rate', headerClass: 'text-end', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const exportToPdf = () => {
        let subHeading = `Auction - ${summaryReportData.shortName} e-Auction ${summaryReportData.auctionNo} (${moment(summaryReportData.auctionDate).format('DD-MMM-YYYY')})`
        let headerRow = gridApi.getColumnDefs().map(t => t.headerName);
        let rows = detailReportData.map(t => [
            { text: t.lotNumber != null ? t.lotNumber : '', alignment: "center" },
            t.auctioneer != null ? t.auctioneer : '',
            { text: t.quantityKg != null ? t.quantityKg+' Kg' : '', alignment:"center" },
            { text: t.bags != null ? t.bags : '', alignment:"center" },
            { text: t.litreWeightGms != null ? t.litreWeightGms : '', alignment: "center" },
            { text: t.rate != null ?'₹ '+ t.rate : '--', alignment: "center" },
        ])

        let body = [headerRow, ...rows]

        const documentDefinition = {
            content: [
                { text: "Auction Price Report", bold: true, fontSize: 14, alignment: "center" },
                { text: subHeading,fontSize:10, margin:[0,5,0,20], alignment: "center" },
                {
                    style: 'tableExample2',
                    table: {
                        headerRows: 1,
                        widths: [34, 220, 50, 30, 60, 50],
                        body: body
                    },layout: {
                        paddingLeft: (i, node) => 5,
                        paddingRight: (i, node) => 5,
                        paddingTop: (i, node) => 5,
                        paddingBottom: (i, node) => 5
                    }
                },
            ],
            styles: {
                tableExample2: {
                    width: '100%',
                    fontSize: 10, // Set the font size for the table
                },
            }
        };

        // Create and open the PDF
        pdfMake.createPdf(documentDefinition,"Auction Price Report.pdf").download();
    }

    const exportToExcel = async () => {

        try {
            const { fileName, fileData } = await api.downloadReport('TraderCompletedLots',0);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }

        //const params = {
        //    suppressQuotes: false,
        //    columnSeparator: ',',
        //};

        //const data = gridApi.getDataAsCsv(params);

        //const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        //const fileName = 'Auction Price Report.csv';

        //const link = document.createElement('a');
        //if (link.download !== undefined) {
        //    const url = URL.createObjectURL(blob);
        //    link.setAttribute('href', url);
        //    link.setAttribute('download', fileName);
        //    document.body.appendChild(link);
        //    link.click();
        //    document.body.removeChild(link);
        //}
    };

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Auctions</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/trader')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Completed Lots Report</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        <button className="btn ripple btn-outline-danger pd-x-10 mg-r-10 btn-sm" type="button" onClick={exportToPdf}>
                            <i class="ti ti-import me-2"></i>Export to pdf
                        </button>
                        <button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={exportToExcel}>
                            <i class="ti ti-import me-2"></i>Export to excel
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="d-flex justify-content-around pd-t-10 pd-b-5">
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary pd-4">
                                    <h6 className="mb-0">Total Lots</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <span className="counter"></span>{summaryReportData?.totalLots||'--'}</h4>
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center  text-primary pd-4">
                                    <h6 className="mb-0">Sold Lots</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <span className="counter"></span>{summaryReportData?.soldLots || '--'}</h4>
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary  pd-4">
                                    <h6 className="mb-0">Withdrawn Lots</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <span className="counter"></span>{summaryReportData?.withdrawnLots || '--'}</h4>
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center  text-primary pd-4">
                                    <h6 className="mb-0">Remaining Lots</h6>
                                    <h4 className="mb-1 mg-t-4 number-font ">
                                        <span className="counter "></span>{summaryReportData?.remainingLots || '--'}</h4>
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary pd-4">
                                    <h6 className="mb-0">Total Quantity</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <NumericFormat suffix={' Kg'} displayType="text" value={summaryReportData?.totalQty||0} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                        {/*<span className="counter"></span>{summaryReportData?.totalQty?.toFixed(2)}</h4>*/}
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary pd-4">
                                    <h6 className="mb-0">Sold Quantity</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <NumericFormat suffix={' Kg'} displayType="text" value={summaryReportData?.soldQty || 0} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                        {/*<span className="counter"></span>{summaryReportData?.soldQty?.toFixed(2)}</h4>*/}
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary pd-4">
                                    <h6 className="mb-0">Sold Value</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <NumericFormat prefix={'₹ '} displayType="text" value={summaryReportData?.soldValue || 0} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                        {/*<span className="counter">₹</span>{summaryReportData?.soldValue?.toFixed(2)}</h4>*/}
                                </div>
                            </div>
                            <div className="pe-0 ps-0">
                                <div className="card-body text-center text-primary pd-4">
                                    <h6 className="mb-0">Auction Avg</h6>
                                    <h4 className="mb-1 mg-t-4 number-font">
                                        <NumericFormat prefix={'₹ '} displayType="text" value={summaryReportData?.auctionAverage || 0} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                        {/*<span className="counter">₹</span>{summaryReportData?.auctionAverage?.toFixed(2) || '-'}</h4>*/}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine"
                                }
                            >
                                <AgGridReact
                                    rowHeight={36}
                                    gridOptions={gridOptions}
                                    rowData={detailReportData}
                                    onGridReady={onGridReady}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CompletedLotsReport;



